// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BXK3j6WwuMrAzvdfn9Nt{padding:6px 0 0}.TuvQREgbDos_8bxak2hy{position:relative}.TuvQREgbDos_8bxak2hy:before{background-color:var(--white-50);z-index:var(--zIndex-BASE_10);content:"";position:absolute;top:0;bottom:0;left:0;right:0}.FDTEs190ss2rlcuImz6s{margin-bottom:16px}.ZKFHVEzX2a0d4OpQs9CK{margin-bottom:25px}.Fr7ZxkZCQMY39QMx_tBP{margin-bottom:15px}.ZKFHVEzX2a0d4OpQs9CK:last-of-type{margin-bottom:0}.r2lDZULfM3IC6lXpBU5t{padding:16.5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `BXK3j6WwuMrAzvdfn9Nt`,
	"loading": `TuvQREgbDos_8bxak2hy`,
	"alert": `FDTEs190ss2rlcuImz6s`,
	"section": `ZKFHVEzX2a0d4OpQs9CK`,
	"section--mrb15": `Fr7ZxkZCQMY39QMx_tBP`,
	"sectionMrb15": `Fr7ZxkZCQMY39QMx_tBP`,
	"autoRechargeCard": `r2lDZULfM3IC6lXpBU5t`
};
export default ___CSS_LOADER_EXPORT___;
